

angular.module('bmsApp').factory('QuoteStatusSvc', function ($http, $log, $window, $q, CRUDSvc, QUOTESTATUS_API) {

	return {options: function(params){return CRUDSvc.get(QUOTESTATUS_API.INDEX, params);}}

}).constant('QUOTESTATUS_API', {
	INDEX: 'api/quoteStatus/options'
});